(() => {
  const ROOT_SELECTOR = '[data-sp-install-three]';

  const initSection = (root) => {
    if (root.dataset.spInstallReady === 'true') return;

    const video = root.querySelector('[data-sp-install-video]');
    const playButton = root.querySelector('[data-sp-install-play]');

    const loadVideo = () => {
      if (!video || video.dataset.spInstallLoaded === 'true') return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
      video.dataset.spInstallLoaded = 'true';
    };

    const playVideo = async () => {
      if (!video) return;
      loadVideo();
      try {
        await video.play();
        if (playButton) playButton.hidden = true;
      } catch (error) {
        if (playButton) playButton.hidden = false;
      }
    };

    if (playButton) playButton.addEventListener('click', playVideo);
    if (video) video.addEventListener('error', () => {
      if (playButton) playButton.hidden = false;
    });

    root.spInstallCleanup = () => video?.pause();
    root.dataset.spInstallReady = 'true';
  };

  const init = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initSection(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.(ROOT_SELECTOR)) event.target.spInstallCleanup?.();
  });
})();
